import React, { useMemo, useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchDoctorSpecialization } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const DoctorSpecializationDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
}) => {
  const specializationName = rowData?.specialization_obj
    ? rowData.specialization_obj.specialization
    : rowData?.specialization_name
    ? rowData.specialization_name
    : getValues().specialization;

  const selectedSpecializationId = watch("specialization_id");

  const {
    data: specializations,
    isLoading,
    error,
  } = useQuery(["specializations"], fetchDoctorSpecialization, {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const modifiedData = useMemo(() => {
    return (
      specializations?.data?.data?.map((ele) => ({
        value: ele.id,
        label: ele.specialization,
      })) || []
    );
  }, [specializations]);

  const selectedOption = useMemo(() => {
    return (
      modifiedData.find(
        (option) => option.value === selectedSpecializationId
      ) ||
      modifiedData.find((option) => option.label === specializationName) ||
      null
    );
  }, [modifiedData, selectedSpecializationId, specializationName]);

  // Sirf rowData change hone par SET karo
  useEffect(() => {
    if (rowData?.specialization_id && modifiedData.length > 0) {
      const rowDataOption = modifiedData.find(
        (option) => option.value === rowData.specialization_id
      );
      if (rowDataOption) {
        setValue("specialization_id", rowDataOption.value, {
          shouldValidate: false,
        });
        setValue("specialization", rowDataOption.label, {
          shouldValidate: false,
        });
      }
    }
  }, [rowData?.specialization_id, modifiedData.length]); // Specific dependencies

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Specialization</div>;

  return (
    <>
      <Controller
        name="specialization_id"
        control={control}
        rules={{
          required: required ? "Specialization is required" : false,
          validate: (value) => {
            if (required && !value) return "Specialization is required";
            return true;
          },
        }}
        render={({ field }) => (
          <Select
            {...field}
            options={modifiedData}
            isClearable
            value={selectedOption || null}
            placeholder="Select Specialization"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            onChange={(selectedOption) => {
              const value = selectedOption ? selectedOption.value : "";
              const label = selectedOption ? selectedOption.label : "";

              field.onChange(value);
              setValue("specialization", label, { shouldValidate: false });
            }}
            className={`react-select-container ${
              errors.specialization_id ? "is-invalid" : ""
            }`}
          />
        )}
      />
      {errors.specialization_id && (
        <div className="invalid-feedback">
          {errors.specialization_id.message}
        </div>
      )}
    </>
  );
};

export default DoctorSpecializationDropdown;
